export default [
  'pink',
  'blue',
  'purple',
  'jade',
  'green',
  'lime',
  'mustard',
  'yellow',
  'orange',
  'red',
  'fawn',
  'concrete',
  'moss',
  'dust',
  'petals',
]
